var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 15,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C44A36",
    fillRule: "evenodd",
    d: "M11.368 4H.632C.282 4 0 3.744 0 3.428v-.571c0-.316.283-.572.632-.572h1.894c0-.837.195-1.326.627-1.718C3.585.176 4.124 0 5.05 0h1.9c.926 0 1.465.176 1.897.567.433.392.627.88.627 1.718h1.894c.35 0 .632.256.632.572v.571c0 .316-.283.572-.632.572zM7.711 1.504c-.231-.371-.543-.551-.855-.493H5.144c-.312-.058-.624.122-.855.493-.213.405-.316.95-.283 1.496h3.988c.033-.546-.07-1.09-.283-1.496zM10.621 5a.313.313 0 01.313.332l-.551 8.788a.94.94 0 01-.94.879H2.43a.94.94 0 01-.94-.88L.94 5.332A.313.313 0 011.252 5h9.369zM2.5 7h1l.5 6H3l-.5-6zm6 0h1L9 13H8l.5-6zM6.533 7H7.2l-.333 6H6.2l.333-6zM5.467 7H4.8l.333 6H5.8l-.333-6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default ForwardRef;